
(() => {
  const roots = new WeakSet();

  const animationCSS = `
    @keyframes bounceAttention {
      0%,80%,100% { transform: translateY(0); }
      85% { transform: translateY(-10px); }
      90% { transform: translateY(0); }
      95% { transform: translateY(-5px); }
    }
  `;

  const addAnimation = (root) => {
    if (!root || !root.querySelector || root.querySelector('#chat-animation-style')) return;
    const style = document.createElement('style');
    style.id = 'chat-animation-style';
    style.textContent = animationCSS;

    if (root === document || root.nodeType === 9) {
      (document.head || document.documentElement).appendChild(style);
    } else {
      root.appendChild(style);
    }
  };

  const applyStyles = (root) => {
    if (!root || !root.querySelector) return;
    addAnimation(root);

    const label = root.querySelector('.activator__label');
    const icon = root.querySelector('.activator__icon');
    const button = root.querySelector('.activator');
    const chatIcon = root.querySelector('shopify-chat-icon');

    if (label) {
      label.style.setProperty('font-size', '20px', 'important');
      label.style.setProperty('font-weight', '700', 'important');
    }

    if (icon) {
      icon.style.setProperty('width', '28px', 'important');
      icon.style.setProperty('height', '28px', 'important');

      const svg = icon.querySelector('svg');
      if (svg) {
        svg.style.setProperty('width', '28px', 'important');
        svg.style.setProperty('height', '28px', 'important');
      }
    }

    if (chatIcon) {
      chatIcon.style.setProperty('width', '28px', 'important');
      chatIcon.style.setProperty('height', '28px', 'important');
    }

    if (button) {
      button.style.setProperty(
        'background-color',
        'color-mix(in srgb, var(--activator-bg) 100%, transparent)',
        'important'
      );
      button.style.setProperty('animation', 'bounceAttention 3s infinite', 'important');
    }
  };

  const watchRoot = (root) => {
    if (!root || roots.has(root)) return;
    roots.add(root);

    applyStyles(root);

    // Observe ONLY inside this specific chat shadow root
    new MutationObserver(() => {
      applyStyles(root);
      if (root.querySelectorAll) {
        const children = root.querySelectorAll('*');
        for (let i = 0; i < children.length; i++) {
          if (children[i].shadowRoot) watchRoot(children[i].shadowRoot);
        }
      }
    }).observe(root, {
      childList: true,
      subtree: true,
    });

    if (root.querySelectorAll) {
      const children = root.querySelectorAll('*');
      for (let i = 0; i < children.length; i++) {
        if (children[i].shadowRoot) watchRoot(children[i].shadowRoot);
      }
    }
  };

  const setupChatHost = (host) => {
    if (!host) return;
    if (host.shadowRoot) {
      watchRoot(host.shadowRoot);
    }
    watchRoot(host);
    applyStyles(host);
  };

  const init = () => {
    addAnimation(document);

    // 1. Target existing chat elements directly
    const chatHosts = document.querySelectorAll('shopify-chat, #shopify-chat, .chatbot-container-sdk');
    chatHosts.forEach(setupChatHost);

    // 2. Custom element hook
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-chat').then(() => {
        const chat = document.querySelector('shopify-chat, #shopify-chat, .chatbot-container-sdk');
        if (chat) setupChatHost(chat);
      });
    }

    // 3. User interaction hook: whenever chat is clicked/toggled, ensure styles are active
    document.addEventListener(
      'click',
      (e) => {
        const target = e.target;
        if (
          target &&
          (target.tagName === 'SHOPIFY-CHAT' ||
            (target.closest && target.closest('shopify-chat, #shopify-chat, .chatbot-container-sdk')))
        ) {
          setTimeout(() => {
            const chat = document.querySelector('shopify-chat, #shopify-chat, .chatbot-container-sdk');
            if (chat) setupChatHost(chat);
          }, 100);
        }
      },
      { passive: true }
    );

    // 4. Lightweight observer on top-level body that stops as soon as chat is hooked
    const bodyObserver = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        const nodes = mutations[i].addedNodes;
        for (let j = 0; j < nodes.length; j++) {
          const node = nodes[j];
          if (node.nodeType === 1) {
            if (
              node.tagName === 'SHOPIFY-CHAT' ||
              node.id === 'shopify-chat' ||
              node.classList?.contains('chatbot-container-sdk')
            ) {
              setupChatHost(node);
              bodyObserver.disconnect();
            } else if (node.querySelector) {
              const chat = node.querySelector('shopify-chat, #shopify-chat, .chatbot-container-sdk');
              if (chat) {
                setupChatHost(chat);
                bodyObserver.disconnect();
              }
            }
          }
        }
      }
    });

    bodyObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: false,
    });

    setTimeout(() => bodyObserver.disconnect(), 8000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();